import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MonitoringService } from 'src/app/services/monitoring.service';

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent implements OnInit {
  fromDate: string | null = null;
  toDate: string | null = null;
  functionAppName: ''
  todayDate: Date = new Date();

  dropdownOptions =
    [
      {
        id: 'AVC',
        name: 'accounting-voyage-calculation',
      },
      {
        id: 'ABP',
        name: 'average-bunker-price',
      },
      {
        id: 'BDP',
        name: 'bunker-data-dump',
      },
      {
        id: 'GDD',
        name: 'gvsl-data-dump',
      },
      {
        id: 'MDP',
        name: 'monthly-data-dump',
      },
      {
        id: 'OPDD',
        name: 'op-days-data-dump',
      },
      {
        id: 'ODP',
        name: 'oracle-data-dump',
      },
      {
        id: 'PLS',
        name: 'pool-lng-savings',
      },
      {
        id: 'PSS',
        name: 'pool-scrubber-savings',
      },
      {
        id: 'SCD',
        name: 'scrubber-calculation-data',
      },
      {
        id: 'SID',
        name: 'scrubber-ifo-data',
      },
      {
        id: 'UVD',
        name: 'update-vessels-data',
      },
      {
        id: 'UVDHTTP',
        name: 'update-vessels-data-http',
      },
      {
        id: 'VLS',
        name: 'voyage-lng-savings',
      },
    ]
  filterLogs: any;
  noFilter = true;

  constructor(private monitoringService: MonitoringService, private datePipe: DatePipe) { }
  ngOnInit() {
  }
  onTimeChange(event) {
  }
  selectedFromDate(fromDate) {
    let date = new Date(fromDate);
    this.fromDate = this.datePipe.transform(date, "YYYY-MM-dd'T'HH:mm:ss'Z'");
  }
  selectedToDate(toDate) {
    let date = new Date(toDate);
    this.toDate = this.datePipe.transform(date, "YYYY-MM-dd'T'HH:mm:ss'Z'");
  }
  selectedValues(value) {
    this.functionAppName = value.selectedRecords.name
  }

  getLog() {
    let payload = {
      "fromDate": this.fromDate,
      "toDate": this.toDate,
      "resourceType": "Function App",
      "functionAppName": this.functionAppName
    }
    this.monitoringService.getLogs(payload).subscribe({
      next: (res: any) => {
        this.filterLogs = res;
        this.noFilter = false;
      }
    })
  }

  downloadTxtFile() {
    const logs = this.filterLogs.data.getLog.data.map(log => `${log.timestamp} ${log.message}`).join('\n');
    const blob = new Blob([logs], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'logs.txt';
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
